import uuid from "uuid/v4";
import * as types from "./types";

export const addCollege = () => {
  const newCollege = {
    id: uuid(),
    name: ''
  };
  return {
    type: types.ADD_COLLEGE,
    newCollege
  }
};

export const removeCollege = (collegeId) => {
  return {
    type: types.REMOVE_COLLEGE,
    collegeId
  }
};

export const updateCollege = (collegeId, updates) => {
  return {
    type: types.UPDATE_COLLEGE,
    collegeId,
    updates
  }
};

export const updateApplication = (updates) => {
  return {
    type: types.UPDATE_APPLICATION,
    updates
  }
};

export const addDegree = () => {
  const newDegree = {
    id: uuid(),
    name: ''
  };
  return {
    type: types.ADD_DEGREE,
    newDegree
  }
};

export const removeDegree = (degreeId) => {
  return {
    type: types.REMOVE_DEGREE,
    degreeId
  }
};

export const updateDegree = (degreeId, updates) => {
  return {
    type: types.UPDATE_DEGREE,
    degreeId,
    updates
  }
};

export const beginSubmitApplication = () => {
  return {
    type: types.SUBMIT_APPLICATION_REQUEST
  }
};

export const submitApplicationSuccess = (application) => {
  return {
    type: types.SUBMIT_APPLICATION_SUCCESS,
    application
  }
};

export const submitApplicationFailure = () => {
  return {
    type: types.SUBMIT_APPLICATION_FAILURE
  }
};

export const beginFetchApplication = () => {
  return {
    type: types.FETCH_APPLICATION_REQUEST
  }
};

export const fetchApplicationSuccess = (application) => {
  return {
    type: types.FETCH_APPLICATION_SUCCESS,
    application
  }
};

export const fetchApplicationFailure = () => {
  return {
    type: types.FETCH_APPLICATION_FAILURE
  }
};

export const applicationDoesNotExist = () => {
  return {
    type: types.APPLICATION_DOES_NOT_EXIST
  }
};